var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYogurt = function SvgYogurt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yogurt_svg__a)",
    d: "M183.877 101.924c-17.122-7.084-10.95-21-26.877-28s-14.932-4.555-21.9-9.778-18.913 8.778-31.854 15.78c-12.941 7-28.867 15-33.845 31.999-4.978 17 37.827 16 45.79 14s58.164-5.171 62.927-2.586 22.682-14.415 5.759-21.415"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yogurt_svg__b)",
    d: "M237 119c-12.092-7.724-32.8-7.509-37.812-10.508s-5.378-9.95-14.225-9.974c-8.847-.023-16.371 1.477-21.386-2.522s-10.032-12-26.082-12-19.06 6-33.1 9-39.123 6-43.136 16.994 40.126 42.986 71.224 41.986C160.779 151.067 239 135 239 123a4.58 4.58 0 0 0-2-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yogurt_svg__c)",
    d: "M33 119c10.326-7.687 36.213-10.669 40.233-12.638s10.565-9.228 28.143-4.923c4.021.984 15.077-3.939 21.108-1.969s17.087 11.814 24.122 13.784 18.092 2.953 22.113 4.922 12.061-4.922 30.153.985S224 131.96 224 131.96s-42.215 19.692-105.537 16.738c-54.376-2.536-88.468-14.7-88.463-24.7 0-1.998 1.225-3.677 3-4.998"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yogurt_svg__d)",
    d: "M135 140.646c53.559 0 114.127-12.158 101.928-21.646 11.139 7.922-3.1 15.321-12.55 30.913C209.1 175.083 182.489 207 135 207s-74.1-31.917-89.378-57.087c-9.45-15.592-23.689-22.991-12.55-30.913-12.199 9.488 48.369 21.646 101.928 21.646"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "yogurt_svg__a",
    x1: 73.147,
    x2: 178.751,
    y1: 99.033,
    y2: 72.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    stopColor: "#268EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#449EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#75B8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#B9DAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yogurt_svg__b",
    x1: 71.15,
    x2: 193.151,
    y1: 120.174,
    y2: 91.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    stopColor: "#268EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#449EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#75B8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#B9DAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yogurt_svg__c",
    x1: 39.312,
    x2: 219.15,
    y1: 124,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#268EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#449EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#75B8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#B9DAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yogurt_svg__d",
    x1: 29,
    x2: 241,
    y1: 163,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgYogurt;